module.exports = __webpack_public_path__ + "static/media/RationalDisplay-Medium.0b7513c1.ttf";